// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T0oy","footer":"styles_footer__noJqJ"};